import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=33c3d302&"
import script from "./Loader.vue?vue&type=script&lang=ts&"
export * from "./Loader.vue?vue&type=script&lang=ts&"
import style0 from "./Loader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports